import { useEffect } from "react";
import { identifyUser } from "@/components/analytics";

export function useGclid() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const gclid = new URLSearchParams(window.location.search).get("gclid");
    if (!gclid) return;
    identifyUser({ gclid });
  }, []);
}
